angular.module('app').controller('ProductsCtrl', listCtrlFactory('product'));
angular.module('app').controller('PriceListsCtrl', listCtrlFactory('price_list'));
angular.module('app').controller('PhotosCtrl', listCtrlFactory('photo'));
angular.module('app').controller('FranchisesCtrl', listCtrlFactory('franchise'));
angular.module('app').controller('MoodsCtrl', listCtrlFactory('mood'));
angular.module('app').controller('CouponsCtrl', listCtrlFactory('coupon'));
angular.module('app').controller('IncentivesCtrl', listCtrlFactory('incentive'));
angular.module('app').controller('TerritoriesCtrl', listCtrlFactory('territory'));
angular.module('app').controller('OrdersCtrl', listCtrlFactory('orders'));
angular.module('app').controller('TemplatesCtrl', listCtrlFactory('template'));
angular.module('app').controller('CommunicationsCtrl', listCtrlFactory('communication'));
angular.module('app').controller('OrbOrdersCtrl', listCtrlFactory('orb_order'));

angular.module('app').controller('TemplateCtrl', itemCtrlFactory('template'));
angular.module('app').controller('IncentiveCtrl', itemCtrlFactory('incentive'));
angular.module('app').controller('NotificationCtrl', itemCtrlFactory(
    'notification',
    {'defaults': {'type': 'custom', 'enabled': true, 'config': {}}}
));
angular.module('app').controller('QuestionCtrl', itemCtrlFactory('event_question'));
angular.module('app').controller('ExpenseCtrl', itemCtrlFactory('expense', {
    'afterSave': function(r, resp, main) {
        main.dialog.hide(resp.data);
    }
}));
